import { __cAuthService } from '@/services/client/__c.auth.service'
import { TSendOtpParams } from '@/types/auth'
import { useMutation } from '@tanstack/react-query'

export const useSendOtpMutation = () => {
  return useMutation({
    mutationKey: ['send-otp'],
    mutationFn: async (body: { address: string; params: TSendOtpParams }) => {
      const response = await __cAuthService.sendOtp(body.address, body.params)
      return response
    },
  })
}
